import isEmpty from "lodash/isEmpty";

import WeaSelect from "../wea-select";
import WeaSystempage from "../wea-browser/coms/WeaSystempage";
import WeaTypeList from "../wea-browser/coms/WeaTypeList";
import WeaBrowserIcons from "../base/wea-browser-icons";
import WeaNodeTreeList from "../base/wea-node-tree-list";
import WeaDevModules from "../base/wea-dev-modules";
import WeaBrowserThumbnail from "../base/wea-browser-thumbnail";
import WeaHrmCondition from "../base/wea-hrm-condition";
import WeaCityPicker from "../wea-city-picker";
import WeaDatePicker from "../wea-date-picker";
import WeaTools from "../wea-tools";

import { defaultProps } from "./browser/propType";
import { getFd } from "../wea-tools/callApi";
import { getPageSize, getValueWarp } from "../wea-browser/coms/util";

export function renderLevelCmps() {
  const { selectOptions } = this.state;
  return (
    <div style={{ display: "inline-block", width: "100%" }} ref="selectWrapper">
      {!isEmpty(selectOptions) && (
        <WeaSelect
          {...this.props}
          // layout={this.refs.selectWrapper}
          detailtype={1}
          options={selectOptions}
          style={
            isEmpty(this.props.inputStyle)
              ? { width: 210 }
              : this.props.inputStyle
          }
        />
      )}
    </div>
  );
}

//特殊浏览框
export function renderBrowser() {
  const {
    type,
    dataParams,
    completeParams,
    conditionDataParams,
    destDataParams
  } = this.props;
  let { dataURL, completeURL, conditionURL, pageSize } = this.props;
  completeURL = completeURL || `/api/public/browser/complete/${type}`;
  dataURL = dataURL || `/api/public/browser/data/${type}`;
  conditionURL = conditionURL || `/api/public/browser/condition/${type}`;
  const newProps = {
    ...defaultProps,
    ...this.props,
    dataUrl: `${dataURL}?${getFd(dataParams)}`, // 浏览框数据URL
    completeURL: `${completeURL}?${getFd(completeParams)}`, // 联想搜索URL
    conditionURL: `${conditionURL}?${getFd(conditionDataParams)}` //浏览框高级查询条件URL
  };
  pageSize = pageSize > 0 ? pageSize : getPageSize(this.props);
  const valueWarp = getValueWarp(this.props);
  const otherProps = {
    valueWarp
  };
  const _type = Number(type);
  //过滤defaultProps中的默认url
  const {
    dataURL: dataUrl,
    completeURL: completeUrl,
    conditionURL: conditionUrl,
    ...nodeTreeListDefaultProps
  } = defaultProps;
  const nodeTreeListProps = {
    ...nodeTreeListDefaultProps,
    ...this.props
  };
  if (type == "systempage") {
    // 门户
    return (
      <WeaSystempage
        initFunc={browser => (this.browser = browser)}
        contentHeight={460}
        {...newProps}
        dataURL={dataURL}
        pageSize={pageSize}
        {...otherProps}
      />
    );
  }
  if (type == "browserTypeList") {
    return (
      <WeaTypeList
        initFunc={browser => (this.browser = browser)}
        {...newProps}
        dataURL={`${dataURL}?${getFd(dataParams)}`}
        pageSize={pageSize}
      />
    );
  }
  if (type == "icons") {
    return (
      <WeaBrowserIcons
        initFunc={browser => (this.browser = browser)}
        contentHeight={460}
        {...newProps}
        pageSize={pageSize}
      />
    );
  }
  if (type == "nodeTreeList") {
    return (
      <WeaNodeTreeList
        initFunc={browser => (this.browser = browser)}
        contentHeight={460} //浏览框内容高度
        {...nodeTreeListProps}
        pageSize={pageSize}
      />
    );
  }
  if (type == "devmodules") {
    return (
      <WeaDevModules
        initFunc={browser => (this.browser = browser)}
        contentHeight={410} //浏览框内容高度
        {...newProps}
        pageSize={pageSize}
      />
    );
  }
  if (_type === 184) {
    return (
      <WeaBrowserThumbnail
        contentHeight={450} //浏览框内容高度
        {...newProps}
        pageSize={pageSize}
        destUrl={`/api/public/browser/destData/${type}?${WeaTools.getFd(
          destDataParams
        )}`} // 多选右侧查找数据接口
        {...otherProps}
      />
    );
  }
  if (_type === 141) {
    // 人力资源条件 多选
    return (
      <WeaHrmCondition
        contentHeight={460}
        {...newProps}
        pageSize={pageSize}
        {...otherProps}
      />
    );
  }
  if ([258, 2222, 58, 263].indexOf(_type) !== -1) {
    return (
      <WeaCityPicker
        initFunc={browser => (this.browser = browser)}
        {...newProps}
        pageSize={pageSize}
      />
    );
  }
  if ([2, 19, 290].indexOf(_type) !== -1) {
    return (
      <WeaDatePicker
        initFunc={browser => (this.browser = browser)}
        {...this.props}
      />
    );
  }
  if (_type === 34) {
    return this.renderLevelCmps();
  }
  return null;
}



// WEBPACK FOOTER //
// ./ecology9/wea-browser-test/specialBrowser.js